import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Dashboard from './Dashboard';
import LiveActivityTiles from './LiveActivityTiles';
import StuckClocks from './StuckClocks';
import VideoLookup from './VideoLookup';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Navigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

export default function AuthenticatedDashboard() {
  const { user, loading } = useAuth();
  
  // Show loading state while authentication is being checked
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  return (
    <>
      <Paper elevation={1} sx={{ p: 2, mb: 3, bgcolor: '#f8f5ff' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6" color="primary">
            Welcome, {user.displayName || user.email.split('@')[0]}!
          </Typography>
        </Box>
      </Paper>
      {/* Above the report, and outside it: these must still show when the
          summary below fails to load. */}
      <LiveActivityTiles />
      <StuckClocks />
      <VideoLookup from={{ label: 'Dashboard', path: '/' }} />
      <Dashboard />
    </>
  );
} 